// THE CONNECTED RUN (3.28.0). Owner, 2026-10-23: "make it so when I double-click a component it selects it and all the
// connected, so I can select an entire pipeline and change its layer."
//
// Two parts are connected when a pipe end is attached to the other part: a fitting, a pump, a lint pot, a valve, or the
// end of another pipe (meta.pipe.a / .b of kind "port"). The run of a part is every part reached through those joins.
// Pure: no store, no UI. tests/connectedRun.test.ts covers it.
import type { Doc } from "../doc/entities";
import { pipeMetaOf } from "./api";

/** For each part, the parts a pipe joins it to. */
function joins(doc: Doc): Map<string, Set<string>> {
  const out = new Map<string, Set<string>>();
  const link = (a: string, b: string) => {
    if (!doc.entities[a] || !doc.entities[b] || a === b) return;
    (out.get(a) ?? out.set(a, new Set()).get(a)!).add(b);
    (out.get(b) ?? out.set(b, new Set()).get(b)!).add(a);
  };
  for (const e of Object.values(doc.entities)) {
    if (e.type !== "group" || !e.meta?.pipe) continue;
    const pm = pipeMetaOf(e);
    if (!pm) continue;
    for (const end of [pm.a, pm.b]) if (end.kind === "port") link(e.id, end.ownerId);
  }
  return out;
}

/** The ids of the part `id` and of every part connected to it, `id` first. Only `id` when nothing is joined to it. */
export function connectedRun(doc: Doc, id: string): string[] {
  if (!doc.entities[id]) return [];
  const map = joins(doc);
  const seen = new Set<string>([id]);
  const queue = [id];
  while (queue.length) {
    const next = queue.shift()!;
    for (const other of map.get(next) ?? []) {
      if (seen.has(other)) continue;
      seen.add(other);
      queue.push(other);
    }
  }
  return [...seen];
}
